import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuote = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 6.95c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h.61c.642 0 .963 0 1.225.073a2 2 0 0 1 1.392 1.392c.073.262.073.583.073 1.225v.139c0 .833 0 1.25-.028 1.66a12 12 0 0 1-.896 3.796c-.159.38-.345.753-.718 1.499-.079.158-.118.237-.167.303a1 1 0 0 1-.646.4c-.08.013-.17.013-.346.013H3.5l2-4h-.55c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1.75 8.73 1.75 8.17 1.75 7.05v-.1Zm10 2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h.61c.642 0 .963 0 1.225.073a2 2 0 0 1 1.392 1.392c.073.262.073.583.073 1.225v.139c0 .833 0 1.25-.028 1.66a12 12 0 0 1-.896 3.796c-.159.38-.345.753-.718 1.499-.079.158-.118.237-.166.303a1 1 0 0 1-.647.4c-.08.013-.17.013-.346.013H13.5l2-4h-.55c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108v-.1Z"
	})]
});
const ForwardRef = forwardRef(SvgQuote);
export { ForwardRef as ReactComponent };
